import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Transformation } from "../../transformation/Transformation.js";
import { VideoSource } from "../../qualifiers/source/sourceTypes/VideoSource.js";
import { createSourceFromModel } from "../../internal/models/createSourceFromModel.js";
/**
 * @description Class for Concatenating another video.
 *
 * <b>Learn more</b>: {@link https://cloudinary.com/documentation/video_manipulation_and_delivery#concatenating_videos|Concatenating videos}
 * @extends SDK.Action
 * @memberOf Actions.VideoEdit
 * @see Visit {@link Actions.VideoEdit|VideoEdit} for an example
 */

var ConcatenateAction = /*#__PURE__*/function (_Action) {
  _inherits(ConcatenateAction, _Action);

  var _super = _createSuper(ConcatenateAction);

  /**
   *
   * @param {Qualifiers.Source.VideoSource | Qualifiers.Source.ImageSource | Qualifiers.Source.FetchSource} source
   *         the Source to concatenate
   */
  function ConcatenateAction(source) {
    var _this;

    _classCallCheck(this, ConcatenateAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'concatenate',
      source: source.toJson()
    };
    _this.concatSource = source;
    return _this;
  }
  /**
   * @description Sets the transition between a video and a concatenated source
   * @param {Qualifiers.Transition.VideoSource} source The source to concatenate.
   * @return {this}
   */


  _createClass(ConcatenateAction, [{
    key: "transition",
    value: function transition(source) {
      this._actionModel.transition = source.toJson();
      this._transition = source;
      return this;
    }
    /**
     * @description Prepend the concatenated video - Adds the video before the original
     * @return {this}
     */

  }, {
    key: "prepend",
    value: function prepend() {
      this._actionModel.prepend = true;
      this._prepend = true;
      return this;
    }
    /**
     * The duration in seconds
     * @param {number} sec
     * @return {this}
     */

  }, {
    key: "duration",
    value: function duration(sec) {
      this._actionModel.duration = sec;
      this._duration = sec;
      return this;
    }
    /**
     * @description Get the transitionString for the toString() method
     * @return {string}
     */

  }, {
    key: "getTransitionString",
    value: function getTransitionString() {
      var transTx = this._transition.getTransformation();

      return ["e_transition,".concat(this._transition.getOpenSourceString('l')), transTx && transTx.toString(), 'fl_layer_apply'].filter(function (a) {
        return a;
      }).join('/');
    }
    /**
     * @description Get the string representation of the Concatenation action
     */

  }, {
    key: "toString",
    value: function toString() {
      /*
       *
       * The toString() method is composed of several steps due to the complex nature of the concatenate transformation.
       *
       * First, we calculate the open and close parts of the top-level transformation:
       *   - {open}/{sourceTransformation}/{close}
       *
       * Unlike a regular overlay, there are multiple 'bits' appended to the open and close parts of the tx.
       * - duration (du_) might be prepended on the opening of the layer (du_5,l_sample)
       * - fl_splice is also added, but only if a transition is not needed.
       *
       * once we've calculated the open and close parts, we now need to deal with the Transition.
       * the transition is an inner transformation on the source with a special effect (e_transition) appended to it.
       *
       * To calculate the transition string, we need to take the transformation from the source(assuming it has one)
       */
      // Calculate the open part
      var open = [this._duration && "du_".concat(this._duration), !this._transition && "fl_splice", "".concat(this.concatSource.getOpenSourceString('l'))].filter(function (a) {
        return a;
      }).join(','); // Calculate the open part

      var close = ['fl_layer_apply', this._prepend && 'so_0'].filter(function (a) {
        return a;
      }).join(','); // Calculate the Transition part

      var concatSourceTx;

      if (this.concatSource.getTransformation()) {
        concatSourceTx = this.concatSource.getTransformation();
      } else {
        concatSourceTx = new Transformation();
      }

      if (this._transition) {
        concatSourceTx.addTransformation(this.getTransitionString());
      } // Put it all together, the transition is already part of the concatSourceTx


      return [open, concatSourceTx.toString(), close].filter(function (a) {
        return a;
      }).join('/');
    }
  }], [{
    key: "fromJson",
    value: function fromJson(actionModel, transformationFromJson) {
      var source = actionModel.source,
          transition = actionModel.transition,
          prepend = actionModel.prepend,
          duration = actionModel.duration;
      var sourceInstance = createSourceFromModel(source, transformationFromJson); // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      var result = new this(sourceInstance);

      if (transition) {
        result.transition(VideoSource.fromJson(transition, transformationFromJson));
      }

      if (prepend) {
        result.prepend();
      }

      if (duration) {
        result.duration(duration);
      }

      return result;
    }
  }]);

  return ConcatenateAction;
}(Action);

export default ConcatenateAction;